module.exports = __webpack_public_path__ + "static/media/closeIcon.df85e50d.svg";